import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { SelectedEntity } from '@common/types/layout.type';

import type { NormalizedColumnEntity, WebWidgetEntity } from '@web/types';

import { WidgetsFacade } from '@web/store/page-structure/widgets/widgets.facade';

import { NavigationWidgetItemComponent } from '../navigation-widget-item';

@Component({
    selector: 'web-navigation-zero-column-item',
    templateUrl: './navigation-zero-column-item.component.html',
    styleUrls: ['./navigation-zero-column-item.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavigationWidgetItemComponent],
})
export class NavigationZeroColumnItemComponent {
    public readonly entity = input.required<NormalizedColumnEntity>();
    public readonly selectedEntity = input.required<SelectedEntity>();

    private readonly widgetsFacade: WidgetsFacade = inject(WidgetsFacade);

    private readonly widgetsEntities = toSignal(this.widgetsFacade.widgetsEntities$, { initialValue: {} });

    public readonly widgets = computed(() => {
        const widgets = this.widgetsEntities();
        return this.entity().children.map(({ id }) => widgets[id] as WebWidgetEntity);
    });
}
